import { render, staticRenderFns } from "./pageCard.vue?vue&type=template&id=ca989926&scoped=true"
import script from "./pageCard.vue?vue&type=script&lang=js"
export * from "./pageCard.vue?vue&type=script&lang=js"
import style0 from "./pageCard.vue?vue&type=style&index=0&id=ca989926&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca989926",
  null
  
)

export default component.exports